import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import AbEnvironment from "../auth/AbEnvironment";


const abEnvironment = new AbEnvironment();
const mutation = graphql`
mutation FormDetailUpdateMutation($input: UpdateFormDetailTByFormDetailIdInput!) {
  updateFormDetailTByFormDetailId (input: $input) {
    formDetailT {
      formDetailId
    }
  }
}
`;

function commit(formDetailId, field) {
  //field should prep things to be named "qKey", "qName", etc... If not, need to adjust
  
  var variables = {
    input: {
      formDetailId: formDetailId,
      formDetailTPatch: {...field}
    }
  };

  //default is only nullable column
  if (field.qDefault && field.qDefault === '') {
    variables.input.formDetailTPatch.qDefault = null;
  }

  //the function to run on promise
  return new Promise((resolve, reject) => {

    commitMutation(abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: response => {
          resolve(response);
        },
        onError: error => {
          reject(error);
        }
      });
  });
}

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { commit };